import { render, staticRenderFns } from "./IdentifierTextField.vue?vue&type=template&id=537e0b98&"
import script from "./IdentifierTextField.vue?vue&type=script&lang=js&"
export * from "./IdentifierTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports